import React from 'react'
import Header from './common/Header'

function Contact() {
	return (
		<>
		<Header/>
			<section className="section2" id="" data-section="section1">
				<div className="container">
					<div className="caption">
						<div className="add-line">
						</div>
						<div className="btm-form" style={{ padding: "50px 15px 50px" }}>
							<div className="pb-5">
								<div className="col-md-11 m-auto">
									<h1 className="mb-5 text-center"><b>Need Assistance With Your Airdrop?</b></h1>
									<div data-v-90fa70b0="" className="mt-4 pt-2 article-content">
										<p>If you do require any assistance with your token airdrop, then please do get in touch and we will be happy to help you. You can ask us anything and also make recommendations on how you think the website could be improved.</p>
										<p>Fill in the form below and we will get back to you by the next working day.</p>
										<div id="app">
											<form className="vue-form">
												<fieldset>
													<div><label htmlFor="name" className="label">Full Name</label> <input type="text" name="name" id="name" required="required" /></div>
													<div><label htmlFor="email" className="label">Email</label> <input type="email" name="email" id="email" required="required" className="email" /></div>
													<div><label htmlFor="textarea" className="label">Message</label> <textarea name="textarea" id="textarea" required="required" maxLength="2000" className="message"></textarea> <span className="counter">0 / 2000</span></div>
													<div className="innfour1 "><button type="button" className="btn-send">Send</button></div>
												</fieldset>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Contact